export default __webpack_public_path__ + "static/media/sbo-icon.975d9f35.svg";